import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(
  <React.StrictMode>
    <App friendsList={{
    foo: {checks: {hangOut: {me: true, them: true}}, bio: "foo bar"},
    foo2: {checks: {hangOut: {me: true, them: false}}, bio: "foo bar"},

    }} />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
console.log('buck loves claire');